import React, { ReactNode } from 'react';
import { Probe, ProbeStatus } from './types';
import StatusPill from './status-pill';

interface Props {
	title: string;
	source: string;
	probe: Probe<unknown> | undefined;
	children: ReactNode;
}

/**
 * Card wrapper shared by every health panel. Owns the status/latency header and
 * the loading, idle and error states so panels only render their own data.
 */
export default function HealthPanel({
	title, source, probe, children,
}: Props) {
	// Degraded still carries data - it means the service was slow, not silent.
	const hasData = !!probe
		&& (probe.status === ProbeStatus.Ok || probe.status === ProbeStatus.Degraded);

	return (
		<section className='health-panel'>
			<header className='health-panel__header'>
				<div>
					<h3 className='health-panel__title'>{title}</h3>
					<span className='health-panel__source'>{source}</span>
				</div>
				<div className='health-panel__status'>
					{probe && <StatusPill status={probe.status} />}
					{probe && (
						<span className='health-panel__latency'>
							{probe.httpStatus || '—'} · {probe.latencyMs}ms
						</span>
					)}
				</div>
			</header>

			<div className='health-panel__body'>
				{!probe && <p className='health-panel__note'>Loading…</p>}
				{probe && !hasData && <p className='health-panel__note'>{probe.message}</p>}
				{hasData && children}
			</div>
		</section>
	);
}
